import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const PointGrants = lazy(() =>
  import(/* webpackChunkName: "PointGrants" */ '../../components/rewards/PointGrants')
);

export default function PointGrantsComponent({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <PointGrants {...props} />
    </Suspense>
  );
}
